import { render, staticRenderFns } from "./player-importer-page.vue?vue&type=template&id=589b54cd&"
import script from "./player-importer-page.vue?vue&type=script&lang=js&"
export * from "./player-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports